import * as ort from "onnxruntime-web";

export function getInputFromSource(sourceEl,width,height) {
        // 3. Create a temporary canvas to resize
        const tmp = document.createElement("canvas");
        tmp.width = width;
        tmp.height = height;

        const ctxTmp = tmp.getContext("2d", { willReadFrequently: true });
        ctxTmp.drawImage(sourceEl, 0, 0, width, height);

        // 4. Read resized image data
        const imageData = ctxTmp.getImageData(0, 0, width, height);
        const data = imageData.data; // RGBA
        return data;
    }


export function  postprocessing(outputs,params) { 
    let type=params.type;
    let scoreThreshold=params.score_threshold;
    let iouThreshold=params.iou_threshold;
    let nc=params.nc;

    if (type=='modelpack') {
        let box_id = '';
        let mask_id = '';
        let score_id = '';

        for(let key in outputs) {
            const x=outputs[key];
            const shape=x.dims;
            if ((shape.length == 4)  && (shape.at(-2) == 1)) {
                box_id = key;
            } else if (shape.length==3) {
                if (shape.at(-1) == nc)
                    score_id = key;
                else
                    mask_id = key;
            }
            
            
        }

        let masks = null;
        let totalBoxes=0;




        if (mask_id!='') {
            masks = getSlice(outputs[mask_id],0); //  shape (h, w)
        }

        let boxes = [];
        let classes=[];
        let scores = [];

        if (box_id!='') {
            let boxesTensor=getSlice(outputs[box_id],0);
            const boxesData = boxesTensor.data;  // Float32Array
            totalBoxes = boxesData.length / 4;
        
            for (let i = 0; i < totalBoxes; i++) {
            boxes.push([
                boxesData[i*4],
                boxesData[i*4+1],
                boxesData[i*4+2],
                boxesData[i*4+3]
            ]);
            }  
      
        }

        
        if (score_id!='') {
            let scoresTensor = getSlice(outputs[score_id],0); // shape (n, num_classes)
            const scoresData = scoresTensor.data;
            const numClasses = scoresData.length / totalBoxes;
            for (let i = 0; i < totalBoxes; i++) {
                scores.push(Array.from(scoresData.slice(i*numClasses, (i+1)*numClasses)));
            }

            // 3️⃣ Get classes = argmax along axis=1
            classes = scores.map(row => {
            let maxIdx = 0;
            let maxVal = row[0];
            for (let j = 1; j < row.length; j++) {
                if (row[j] > maxVal) {
                maxVal = row[j];
                maxIdx = j;
                }
            }
            return maxIdx;
            });


            let max_scores = scores.map(row => Math.max(...row));

            // 5️⃣ Filter by minimum score
            let filt = [];
            for (let i = 0; i < max_scores.length; i++) {
            if (max_scores[i] >= scoreThreshold) filt.push(i);
            }

            // 6️⃣ Apply filter
            scores = filt.map(i => max_scores[i]);
            boxes = filt.map(i => boxes[i]);
            classes = filt.map(i => classes[i]);

            // 7️⃣ Non-Max Suppression
            let keep = numpyNMS(boxes, scores, iouThreshold);
            boxes = keep.map(i => boxes[i]);
            classes = keep.map(i => classes[i]);
            scores = keep.map(i => scores[i]);


        }
        

        return {
            boxes:      boxes,
            classes:    classes,
            scores:     scores,
            mask:       masks,
        } 

    }
}

function numpyNMS(boxes, scores, iouThreshold = 0.7, maxDetections = 300, eps = 1e-7) {
    if (boxes.length === 0) return [];

    const x1 = boxes.map(b => b[0]);
    const y1 = boxes.map(b => b[1]);
    const x2 = boxes.map(b => b[2]);
    const y2 = boxes.map(b => b[3]);

    const areas = boxes.map((b, i) => (x2[i] - x1[i]) * (y2[i] - y1[i]));
    const order = scores.map((s, i) => i).sort((a, b) => scores[b] - scores[a]);

    const keep = [];
    while (order.length > 0) {
        const i = order[0];
        keep.push(i);
        if (keep.length >= maxDetections) break;

        const rest = order.slice(1);
        const inds = [];
        for (let idx = 0; idx < rest.length; idx++) {
            const j = rest[idx];
            const xx1 = Math.max(x1[i], x1[j]);
            const yy1 = Math.max(y1[i], y1[j]);
            const xx2 = Math.min(x2[i], x2[j]);
            const yy2 = Math.min(y2[i], y2[j]);
            const w = Math.max(0.0, xx2 - xx1);
            const h = Math.max(0.0, yy2 - yy1);
            const inter = w * h;
            const union = areas[i] + areas[j] - inter;
            const iou = inter / (union + eps);
            if (iou <= iouThreshold) inds.push(idx);
        }
        order.splice(0, order.length, ...inds.map(i => rest[i]));
    }

    return keep;
}


function getSlice(tensor, n) {
    const dims = tensor.dims;
    const batch = dims[0];

    if (n < 0 || n >= batch) {
        throw new Error(`Index out of bounds: ${n} for batch size ${batch}`);
    }

    const innerSize = tensor.data.length / batch; // number of elements per slice
    const start = n * innerSize;
    const end = start + innerSize;

    const sliceData = tensor.data.subarray(start, end); // zero-copy view
    const newShape = dims.slice(1); // remove first dimension

    return new ort.Tensor(tensor.type, sliceData, newShape);
}